module.exports = __webpack_public_path__ + "static/ar-a281ab3fed93623da8f86659f5059b5d.png";